import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_SERVICES, UPDATE_SERVICE_STATUS, DELETE_SERVICE, ADD_SERVICE, EDIT_SERVICE, SERVICE_DETAILS, QUESTION_DROPDOWN_LIST, UPDATE_SERVICES_ORDER_STATUS } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import {
  GetServicesSuccess,
  GetServicesFailure,
  UpdateServiceStatusSuccess,
  UpdateServiceStatusFailure,
  DeleteServiceSuccess,
  DeleteServiceFailure,
  AddServiceSuccess,
  AddServiceFailure,
  EditServiceSuccess,
  EditServiceFailure,
  ServiceDetailsSuccess,
  ServiceDetailsFailure,
  QuestionDropdownListSuccess,
  QuestionDropdownListFailure,
  UpdateServiceOrderStatusSuccess,
  UpdateServiceOrderStatusFailure,
} from "../Actions/ServicesAction";

function* GetServicesRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/services/${actions.payload.module_type}?status=${actions.payload.status}&user_type=${actions.payload.user_type}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetServicesSuccess(res.data));
    } else {
      yield put(GetServicesFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetServicesFailure(e));
  }
}

function* GetServicesDetailsRequest(actions) {
  try {
    //alert(1);
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/service_details/${actions.payload}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(ServiceDetailsSuccess(res.data));
    } else {
      yield put(ServiceDetailsFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(ServiceDetailsFailure(e));
  }
}

function* UpdateServiceStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_service_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateServiceStatusSuccess(res.data));
    } else {
      yield put(UpdateServiceStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateServiceStatusFailure(e));
  }
}

function* DeleteServiceRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/service/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteServiceSuccess(res.data));
    } else {
      yield put(DeleteServiceFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteServiceFailure(e));
  }
}

function* AddServiceRequest(actions) {
  const formData = new FormData();
  formData.append("title", actions.payload.title);
  // formData.append("ios_icon", actions.payload.ios_icon);
  // formData.append("android_icon", actions.payload.android_icon);
  formData.append("icon", actions.payload.icon);
  formData.append("header_title", actions.payload.header_title);
  formData.append("request_button_title", actions.payload.request_button_title);
  formData.append("user_type", actions.payload.user_type);
  formData.append("type", actions.payload.type);
  actions.payload.start_time !== undefined && formData.append("start_time", actions.payload.start_time);
  actions.payload.start_time !== undefined && formData.append("end_time", actions.payload.end_time);
  actions.payload.start_time !== undefined && formData.append("onfleet_type", actions.payload.onfleet_type);
  formData.append("information", actions.payload.information);
  actions.payload.start_time !== undefined && formData.append("question", JSON.stringify(actions.payload.question));
  formData.append("module_type", JSON.stringify(actions.payload.module_type));
  formData.append("app_android_url", actions.payload.app_android_url);
  formData.append("app_ios_url", actions.payload.app_ios_url);

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_service`, formData, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(AddServiceSuccess(res.data));
    } else {
      yield put(AddServiceFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddServiceFailure(e));
  }
}

function* EditServiceRequest(actions) {
  const formData = new FormData();
  formData.append("id", actions.payload.id);
  formData.append("title", actions.payload.title);
  // formData.append("ios_icon", actions.payload.ios_icon);
  // formData.append("android_icon", actions.payload.android_icon);
  formData.append("icon", actions.payload.icon);
  formData.append("header_title", actions.payload.header_title);
  formData.append("request_button_title", actions.payload.request_button_title);
  formData.append("user_type", actions.payload.user_type);
  formData.append("type", actions.payload.type);
  actions.payload.start_time !== undefined && formData.append("start_time", actions.payload.start_time);
  actions.payload.start_time !== undefined && formData.append("end_time", actions.payload.end_time);
  actions.payload.start_time !== undefined && formData.append("onfleet_type", actions.payload.onfleet_type);
  formData.append("information", actions.payload.information);
  actions.payload.start_time !== undefined && formData.append("question", JSON.stringify(actions.payload.question));
  formData.append("module_type", JSON.stringify(actions.payload.module_type));
  formData.append("app_android_url", actions.payload.app_android_url);
  formData.append("app_ios_url", actions.payload.app_ios_url);
  formData.append("notification_email", actions.payload.notification_email);

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_service`, formData, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(EditServiceSuccess(res.data));
    } else {
      yield put(EditServiceFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditServiceFailure(e));
  }
}

function* GetQuestionListRequest() {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/question_dropdown_list`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(QuestionDropdownListSuccess(res.data));
    } else {
      yield put(QuestionDropdownListFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(QuestionDropdownListFailure(e));
  }
}

function* serviceOrderStatusRequest(actions) {
  let services = [];
  actions.payload.map((arr) => {
    services.push(arr);
  });
  const body = {
    services,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_services_order_number`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateServiceOrderStatusSuccess(res.data));
    } else yield put(UpdateServiceOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateServiceOrderStatusFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_SERVICES, GetServicesRequest);
  yield takeLatest(UPDATE_SERVICE_STATUS, UpdateServiceStatusRequest);
  yield takeLatest(DELETE_SERVICE, DeleteServiceRequest);
  yield takeLatest(ADD_SERVICE, AddServiceRequest);
  yield takeLatest(EDIT_SERVICE, EditServiceRequest);
  yield takeLatest(SERVICE_DETAILS, GetServicesDetailsRequest);
  yield takeLatest(QUESTION_DROPDOWN_LIST, GetQuestionListRequest);
  yield takeLatest(UPDATE_SERVICES_ORDER_STATUS, serviceOrderStatusRequest);
}

export default function* ServicesSaga() {
  yield all([actionWatcher()]);
}
